
import { Modal, Button } from 'react-bootstrap';

const ModalContract = ({ showSignatureModal, setShowSignatureModal, children }) => {

  return (
    <Modal 
      show={showSignatureModal}
      onHide={() => setShowSignatureModal(false)}
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Solicitudes
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {children}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {setShowSignatureModal(false)}}
        >
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalContract;